function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "shield-solid",
  d: "M369.974,0a48.132,48.132,0,0,1,19.764,4.277L667.459,122.121c32.448,13.716,56.636,45.722,56.488,84.364-.737,146.309-60.913,414-315.036,535.68a90.086,90.086,0,0,1-77.874,0C76.913,620.486,16.738,352.793,16,206.484c-.147-38.642,24.041-70.647,56.488-84.364L350.358,4.277A46.952,46.952,0,0,1,369.974,0Z",
  transform: "translate(-16)",
  fill: "#adeb91"
});
function SvgShield2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 707.948,
    height: 751.014,
    viewBox: "0 0 707.948 751.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield2);
export default __webpack_public_path__ + "static/media/shield-2.2bf753cc0b678062a27600d6b53f08c5.svg";
export { ForwardRef as ReactComponent };